import { User, Star, Users } from "lucide-react";
import { Badge, Card } from "react-bootstrap";

// offer object backend se (Tdoffer model):
// id, discount_percent, description, max_users, valid_till, is_active
// + driver: { username, email, phone, ... } (Tddriver model se eager load)

const SingleOfferCard = ({ offer }) => {
  const driver = offer.driver || {};

  return (
    <Card key={offer.id} className="CustomerDashboard-offer-card">
      <Card.Body className="CustomerDashboard-offer-body">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <Badge bg="success" className="CustomerDashboard-offer-discount">
            {offer.discount_percent}% Off
          </Badge>
          <div className="d-flex align-items-center gap-1">
            <Star size={16} fill="#FFB800" color="#FFB800" />
            <span className="CustomerDashboard-offer-rating">
              {driver.rating || "4.5"}
            </span>
          </div>
        </div>

        {/* Driver ka naam separate line mein */}
        <div className="d-flex align-items-center gap-2 mt-2 mb-1">
          <User size={16} color="#1B9B82" />
          <span className="CustomerDashboard-offer-name">
            {driver.drivername || "Driver"}
          </span>
        </div>

        <p className="CustomerDashboard-offer-distance">
          {offer.description}
        </p>

        <div className="d-flex gap-3 mb-2">
          <span className="CustomerDashboard-offer-detail">
            <Users size={14} color="#1B9B82" className="me-1" />
            {offer.max_users} users
          </span>
        </div>

        <p className="CustomerDashboard-offer-valid">
          Valid till:{" "}
          {offer.valid_till
            ? new Date(offer.valid_till).toLocaleDateString()
            : "N/A"}
        </p>
      </Card.Body>
    </Card>
  );
};

export default SingleOfferCard;